<template>
    <div id="navigation" class="navigation">
        <div class="hamburger__menu hidden-desktop">
            <button class="hamburger hamburger--spin" type="button" :class="{'is-active': menuToggle}" @click="menuToggle = !menuToggle">
            <span class="hamburger-box">
                <span class="hamburger-inner"></span>
            </span>
            </button>   
        </div>     
        <div class="logo">
            <router-link :to="{ name: 'section', params: { sectionSlug: root.slug }}">
                <logo/>
            </router-link>
        </div>
        <div class="nav-wrapper" :class="{'active': menuToggle === true}">
            <ul>
                <template v-for="section in sections">
                    <li :key="section.id" v-if="section.type !== 'map' && section.type !== 'search'">
                        <router-link @click.native="menuToggle = false" :to="{ name: 'section', params: { sectionSlug: section.slug }}">{{section.title}}</router-link>
                    </li>                    
                </template>
            </ul>
        </div>
        <div class="search">
            <a href="#" @click.prevent="searchModal = true"><Search/></a>
            <transition name="fade">
                <div class="morphing__modal" v-if="searchModal">
                    <input type="text" v-model="searchInput" :placeholder="appConstants.translations[locale].search" @keyup.enter="searchUrl()" @keydown.esc="searchModal = false" autofocus>
                </div>            
            </transition>
        </div>
        <div class="languages" :class="{'active': menuToggle === true}">
            <a v-if="$route.params.locale !== 'en'" href="#" @click.prevent="changeLanguage('en')">EN</a>
            <a v-else href="#" @click.prevent="changeLanguage('de')">DE</a>
        </div>
    </div>
</template>

<script>
    import simplebar from 'simplebar-vue';
    import {Logo, Search, Close} from '../elements/icons'
    import {changeLanguage} from '../mixins'
    import _find from 'lodash/find'
    export default {
        props: ['sections'],
        components: {
            Logo,
            Search,
            Close,
            simplebar
        },
        mixins: [changeLanguage],
        watch: {
            'searchModal': function (newVal, oldVal) {
                let body = document.querySelector('body')

                if(newVal) {
                    body.classList.add('mode-search')
                } else {
                    body.classList.remove('mode-search')
                }
            },
            '$route': function(val) {
                this.searchModal = false,
                this.searchInput =  ''
            }
        },
        data () {
            return {
                searchModal: false,
                searchInput: '',
                locale: this.$route.params.locale,
                menuToggle: false
            }
        },
        methods: {
            checkviewport () {
                if(window.innerWidth <= 991) {
                    this.menuToggle = false
                }
            },
            searchUrl() {
                this.$router.push({
                    name: 'section',
                    params: {sectionSlug: 'search'},
                    query: {
                        q: this.searchInput
                    }
                });                
            },
            close(e) {
            if (!this.$el.contains(e.target)) {
                this.searchModal = false;
            }
            }            
        },
        created() {
            window.addEventListener("click", this.close);
        },

        beforeDestroy() {
            window.removeEventListener("click", this.close);
        },        
        computed: {
            root () {
                return _find(this.sections, {type: 'root'})
            }
        }        
    }
</script>